export const csrfToken = (): string => {
  const csrfMeta = document.querySelector("meta[name='csrf-token']");
  if (!csrfMeta) {
    return "";
  }
  return csrfMeta.getAttribute("content") || "";
};
